import * as NUMBER from 'constant/number'
import React, { useEffect } from 'react'
import { CATEGORY_RESET, SUB_CATEGORY_RESET } from 'constant/form-item-names'
import { Row, Col, Form } from 'antd'
import PropTypes from 'prop-types'
import FileNameInput from 'view/component/form-items/file-name'
import UploadFile from 'view/component/form-items/upload-file'
import OrganisationSelect from 'view/component/form-items/article-org-select'
import UserTypeSelect from 'view/component/form-items/article-user-type-select'

const defaultFormValues = { published: false }

const AttachmentForm = ({ attachment = defaultFormValues, form }) => {
  useEffect(() => {
    form.setFieldsValue(attachment)
  }, [attachment])

  return (
    <Row gutter={NUMBER.FIFTY}>
      <Col xl={NUMBER.TWENTY_FOUR}>
        <Form
          form={form}
          layout='vertical'
        >
          <FileNameInput />
          <OrganisationSelect hidden={true} />
          <UserTypeSelect />
          <UploadFile fileName={attachment.image_name} />
        </Form>
      </Col>
    </Row>
  )
}

AttachmentForm.propTypes = {
  attachment: PropTypes.object,
  dataset: PropTypes.object,
  form: PropTypes.object
}

export default AttachmentForm
